module.exports = __webpack_public_path__ + "assets/invoca.f88650a7.svg";